// extracted by mini-css-extract-plugin
module.exports = {"chips":"common_carousel-module__chips--34J64","wrapper":"common_carousel-module__wrapper--2Zf0z","inner":"common_carousel-module__inner--2xOuh"};